import { FilterChipsBar } from '@/components/layout/FilterChipsBar';
import { useVariationFilterChips } from '@/hooks/useFilterChips';

/**
 * Active-filter chips for the Variations page (same FilterChipsBar as the Creator).
 */
export const VariationFiltersIndicator = () => {
  const { chips, clearAll } = useVariationFilterChips();
  return <FilterChipsBar chips={chips} onClearAll={clearAll} />;
};
